import React from 'react'
import {FormattedTime} from 'react-intl';
import IntlMessages from '../../helpers/IntlMessages';
import Badge from 'react-bootstrap/Badge'
import SpeakerFlag from '../Speakers/SpeakerFlag'
import ThumbnailImage from '../Speakers/ThumbnailImage'
import Utils from '../Utils'
import './style.css'
import SpeakerItemInList from '../Speakers/SpeakerItemInList';
import Storage from '../Storage'
export class SessionChildActivities extends React.Component{
    _getActivitySpeakers(activity){
       const {speakers} = this.props
       //gec: Importante! si es undefined es porque estamos renderizando las actividades del Speaker
       if (speakers != undefined) {
            var actSpks = speakers.filter( spk => activity.speakerIds.includes(parseInt(spk.id)))
            if (actSpks.length != 0 ){
                //Esto le asigna el order porq en el speaker no esta
                actSpks.forEach(speaker=>
                    speaker.speakerOrder = activity.speakerActivity.find(spa => spa.idSpeaker == speaker.id).speakerOrder
                    )
            }
            return actSpks.length == 0 ? null : 
        
            actSpks.sort((a,b)=>a.speakerOrder - b.speakerOrder).map(speaker => 
                
            <li>
                <SpeakerItemInList speaker={speaker} role={speaker.speakerActivity.find(spa => spa.idActivity == activity.id).speakerRole} /> 
            </li>)
        }
    }
    getActivityTitle (activity){
        switch (this.props.locale){
            case "en":
                return activity.title_EN != ""?activity.title_EN:activity.title;
            case "es":
                return activity.title_ES != ""?activity.title_ES:activity.title;
            case "pt":
                return activity.title_PT != ""?activity.title_PT:activity.title;
            case "fr":
                return activity.title_FR != ""?activity.title_FR:activity.title;
            default:
                return activity.title;
        }
    }
    getActivityDescription (activity){
        switch (this.props.locale){
            case "en":
                return activity.description_EN !== "" ? activity.description_EN:activity.description;
            case "es":
                return activity.description_ES !== "" ? activity.description_ES:activity.description;
            case "pt":
                return activity.description_PT !== "" ? activity.description_PT:activity.description;
            case "fr":
                return activity.description_FR !== "" ? activity.description_FR:activity.description;
            default:
                return activity.description;

        }
    }
    getActivityAllAuthorText(activity) {
        return activity.allAuthorListText;
    }
    getActivityTrack(activity){
        //TODO: Unificar en una unica funcion compartida con sessionbyday
        const {actTracks} = this.props
        const idTrack = activity.idActivityTrack
        if (idTrack == 0){
            return ""
        }
        const track = actTracks.find( track => track.id == idTrack)
        switch(this.props.locale){
            case "en":
                return track.name_EN
            case "es":
                return track.name_ES
            case "pt":
                return track.name_PT
            case "fr":
                return track.name_FR
            default:
                return track.name;
        }
    }
    getActivityType(activity){
        //TODO: Unificar en una unica funcion compartida con sessionbyday
        const {actTypes} = this.props
        const idType = activity.idActivityType
        if (idType == 0){
            return ""
        }
        const type = actTypes.find(type => type.id == idType)
        switch(this.props.locale){
            case "en":
                if (type.name_EN) return type.name_EN; break;
            case "es":
                if (type.name_ES) return type.name_ES; break;
            case "pt":
                if (type.name_PT) return type.name_PT; break;
            case "fr":
                if (type.name_FR) return type.name_FR; break;
            default:
                return type.name;
        }
    }
    render() {
        const regex = /(<([^>]+)>)/ig;
        const childActs = this.props.childActs.sort((a, b) => a.startDateTime.localeCompare(b.startDateTime) ||  Number(a.order)  - Number(b.order));
        debugger;
        var moment = require('moment-timezone');
        let tz =  Storage.getTimeZone();
        return <div id="SessionsByDayChildActivities" >
        <table role="table" className="r-table table table-divided">
        <tbody>
        {childActs.map( activity =>  
            <>  
                <tr role="row" key={activity.id} id={activity.id}>
                    <td role="cell" className="list-item-heading ">
                    <Badge pill variant="secondary">
                       <i class="simple-icon-clock"></i>{" "}
                            <FormattedTime
                            value={moment.tz(activity.startDateTime, tz).format()}
                            hour="numeric"
                            minute="numeric"
                            /> {" - "}
                            <FormattedTime
                            value={moment.tz(activity.endDateTime, tz).format()}
                            hour="numeric"
                            minute="numeric"
                            />
                            
                        </Badge>
                         
                      
                        <div class="list-item-heading mb-1 subsessionTitle" dangerouslySetInnerHTML={{__html : this.getActivityTitle(activity)}} ></div>
                        <div class="list-item-heading mb-1 subsessionDescription" dangerouslySetInnerHTML={{__html : this.getActivityDescription(activity)}} />
                        { 
                            this.getActivityTrack(activity) ? 
                            <p class="mb-0 text-muted "><i className="simple-icon-tag"></i> {this.getActivityTrack(activity)}</p> :
                            null     
                        }
                        {
                            this.getActivityType(activity) ? 
                            <p class="mb-0 text-muted"><i className="simple-icon-graduation"></i> {this.getActivityType(activity)}</p> :
                            null     
                        }
                        {
                            activity.room ? 
                            <p class="mb-0 text-muted"><i className="simple-icon-location-pin"></i> {activity.room}</p> :
                            null     
                        }
                         <p  dangerouslySetInnerHTML={{
                                        __html: this.getActivityAllAuthorText(activity),
                                        }}/>
                        {this.props.getVideoLinkForModal(activity) != null && this.props.getVideoLinkForModal(activity) != ''?
                                        <div onClick= {() => this.props.openModal(activity)} className="divActsBadge" >
                                            <Badge pill variant="success"><IntlMessages id="dashboards.seeModal"/></Badge>
                                        </div>                                    
                                        : 
                                        null
                        }
                        <ul>
                            {this._getActivitySpeakers(activity)}
                        </ul>
        
                            {/* { new Date() >= new Date(activity.startDateTime) && new Date() <= new Date(activity.endDateTime) ?     
                                <div onClick= {() => this.openVideoModal(activity)}>
                                 <Badge pill variant="danger">LIVE</Badge>
                                </div>                                       
                                : 
                                null
                            }  */}
                    </td>
                </tr>
            </>
        )}
        </tbody>
    </table>
</div>
    }
}